import { sxTable } from './sxProps';
import './styles.css'
import { Table, TableBody, TableContainer, TableHead, TableCell, TableRow, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';
import { TabelaHistoricoProps } from '../../../../interfaces/props/MeuPlano/Cancelamento/TabelaHistoricoProps';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPrint } from '@fortawesome/pro-light-svg-icons';
import moment from 'moment';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { useAccessibility } from '../../../../Store/contexts/AccessibilityContext';

function TabelaHistorico(props: TabelaHistoricoProps) {

    const { textStyleAccessibility, contrastBorderAccessibility } = useAccessibility();

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        ...{
            fontFamily: 'Unimed-Sans',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 400,
        },
        ...textStyleAccessibility
    }));
      
    const StyledTableRow = styled(TableRow)(({ theme }) => ({
      '&:nth-of-type(odd)': {
          backgroundColor: '#F9F9F9'
      },
    }));

    return (
        <div>
          <TableContainer className='container-table' sx={sxTable} style={contrastBorderAccessibility}  component={Paper}>
            <Table stickyHeader size="small" aria-label="a dense table">
                <TableHead>
                <TableRow>
                    <StyledTableCell><strong>Protocolo</strong></StyledTableCell>
                    <StyledTableCell><strong>Data</strong></StyledTableCell>
                    <StyledTableCell><strong>Nome</strong></StyledTableCell>
                    <StyledTableCell><strong>Cartão Unimed</strong></StyledTableCell>
                    <StyledTableCell><strong>Motivo</strong></StyledTableCell>
                    <StyledTableCell><strong>Canal Utilizado</strong></StyledTableCell>
                    <StyledTableCell><strong>Imprimir</strong></StyledTableCell>
                </TableRow>
                </TableHead>
                <TableBody>
                {props.data.map((row) => (
                    <StyledTableRow
                        key={row.protocolo}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                        <StyledTableCell component="th" scope="row">
                            {row.protocolo}
                        </StyledTableCell>
                        <StyledTableCell align="left">{moment(row.data).format('DD/MM/YYYY')}</StyledTableCell>
                        <StyledTableCell align="left">{row.nomeBeneficiario}</StyledTableCell>
                        <StyledTableCell align="left">{row.codigoBeneficiario}</StyledTableCell>
                        <StyledTableCell align="left">{row.motivo}</StyledTableCell>
                        <StyledTableCell align="left">{row.formaSolic}</StyledTableCell>
                        <StyledTableCell align="center">
                            <FontAwesomeIcon className="print-icon" icon={faPrint as IconProp} onClick={()=> props.onImprimirClicked(row.protocolo)}/>
                        </StyledTableCell>
                    </StyledTableRow>
                ))}
                </TableBody>
            </Table>
            </TableContainer>
        </div>
    )
}

export default TabelaHistorico;